import _ from 'lodash'

export function cleanEntityInclusions (entity, menuBlob, departmentId = null, forPublish = false) {
  if (!_.has(entity, 'inclusions')) return

  const department = forPublish
    ? _.get(menuBlob, 'departments', []).find(dept => dept.id === departmentId)
    : null

  // If forPublish === true then filter out inclusion info for modifiers that are not available in the department.
  const availableCategories = _.get(menuBlob, 'modifiers.categories', [])
    .filter(cat => forPublish !== true ||
      _.get(department, 'modifiers.availability.categories', []).includes(cat.id))
    .map(next => next.id)
  const availableItems = _.get(menuBlob, 'modifiers.items', [])
    .filter(item => forPublish !== true ||
      !_.get(department, 'modifiers.availability.items', []).find(itm => itm.id === item.id && !itm.available))
    .map(next => next.id)

  entity.inclusions.categoriesSettings = entity.inclusions.categoriesSettings
    .filter(({ id }) => availableCategories.includes(id))

  entity.inclusions.itemsSettings = entity.inclusions.itemsSettings
    .filter(({ id }) => availableItems.includes(id))

  entity.inclusions.inclusionsOrder = entity.inclusions.inclusionsOrder
    .filter(({ id }) => availableItems.includes(id))

  entity.inclusions.inclusionsOrder
    .sort((a, b) => a.order - b.order)
    .forEach((it, i) => (it.order = i))
}
